import type { AppLocale, DeepPartialMessageTree } from "@airange/shared/i18n-common";

export const microLabFormMessages: Record<AppLocale, DeepPartialMessageTree> = {
  "zh-CN": {
    microLab: {
      forms: {
        scheme: {
          nameLabel: "方案名称",
          descriptionLabel: "方案说明",
          nameRequired: "请输入方案名称",
          nameMax: "方案名称不能超过 255 个字符",
          nameNonNumeric: "方案名称不能只填数字，请改成正式中文名称或可读标题",
        },
        schemeShare: {
          membersLabel: "共享成员",
          membersPlaceholder: "请选择可查看该方案的成员",
          pickMembersAction: "查找共享成员",
          memberSearchPlaceholder: "搜索用户名或显示名称",
        },
        schemeVersion: {
          nameLabel: "版本名称",
          nameMax: "版本名称不能超过 255 个字符",
          nameNonNumeric: "版本名称不能只填数字，请改成可读标题",
          descriptionLabel: "版本说明",
          objectiveLabel: "实验目标",
          manualLabel: "Markdown 手册",
          manualRequired: "请输入 Markdown 手册",
          markdownEditor: {
            emptyPreview: "当前还没有 Markdown 内容",
            editMode: "编辑",
            splitMode: "分栏",
            previewMode: "预览",
            headingAction: "标题",
            boldAction: "加粗",
            italicAction: "斜体",
            quoteAction: "引用",
            bulletListAction: "无序列表",
            orderedListAction: "有序列表",
            linkAction: "链接",
            codeBlockAction: "代码块",
            headingPlaceholder: "小节标题",
            boldPlaceholder: "加粗内容",
            italicPlaceholder: "斜体内容",
            quotePlaceholder: "引用内容",
            bulletListPlaceholder: "列表项",
            orderedListPlaceholder: "有序列表项",
            linkPlaceholder: "链接文本",
            codeBlockPlaceholder: "代码块",
          },
          environmentKindLabel: "环境类型",
          environmentKindRequired: "请选择环境类型",
          environmentAssetLabel: "环境资产",
          topologyAssetLabel: "拓扑资产",
          environmentAssetRequired: "请选择环境资产",
          environmentImagePlaceholder: "请选择应用镜像资产",
          environmentTopologyPlaceholder: "请选择拓扑资产",
          pickEnvironmentAssetAction: "查找带回",
          clearEnvironmentAssetAction: "清空",
          ksaBindingsLabel: "实验级 KSA 绑定",
          ksaBindingsHelp: "从能力图谱 KSA 分类中选择，保存为方案版本快照里的正式绑定结构。",
          ksaPickerPlaceholder: "请选择 KSA 分类",
          pickKsaAction: "查找带回",
          clearKsaAction: "清空",
          ksaKnowledgeGroupTitle: "Knowledge",
          ksaSkillGroupTitle: "Skill",
          ksaAbilityGroupTitle: "Ability",
          stepsLabel: "结构化步骤",
          addStepAction: "新增步骤",
          stepCardTitle: "步骤 {index}",
          stepTitleLabel: "步骤标题",
          stepTitleRequired: "请输入步骤标题",
          stepInstructionLabel: "步骤说明",
          stepExpectedOutcomeLabel: "预期结果",
          stepKsaBindingsLabel: "步骤级 KSA 绑定",
          stepKsaBindingsHelp:
            "可为单个步骤选择更细的 KSA 分类，用于实验执行和复盘时定位训练目标。",
          submissionNoteLabel: "送审说明",
        },
        library: {
          reuseModeLabel: "复用方式",
          reuseModeRequired: "请选择复用方式",
          targetSchemeNameLabel: "目标方案名称",
          targetSchemeNameRequired: "请输入目标方案名称",
          targetSchemeNameMax: "目标方案名称不能超过 255 个字符",
          targetSchemeNamePlaceholder: "请输入复用后生成的方案名称",
          targetVersionNameLabel: "目标版本名称",
          targetVersionNameMax: "目标版本名称不能超过 255 个字符",
          targetVersionNamePlaceholder: "可选：为首个版本填写易读名称",
        },
        libraryReviews: {
          actionLabel: "处理动作",
          actionRequired: "请选择处理动作",
          reviewCommentLabel: "审核意见",
        },
        release: {
          stepSourceTitle: "来源方案版本",
          stepSourceDescription: "先确认要冻结成发布快照的方案版本。",
          stepSettingsTitle: "发布设置",
          stepSettingsDescription: "确定可见范围、手册可见性和发布名称。",
          stepTargetsTitle: "目标成员",
          stepTargetsDescription: "只有定向发布才需要明确成员名单。",
          stepConfirmTitle: "快照确认",
          stepConfirmDescription: "最后复核发布将冻结的来源与目标范围。",
          sourceSchemeVersionLabel: "来源方案版本",
          sourceSchemeVersionRequired: "请选择来源方案版本",
          sourceSchemeVersionPlaceholder: "请选择来源方案版本",
          pickSourceSchemeVersionAction: "查找带回",
          clearSourceSchemeVersionAction: "清空",
          nameLabel: "发布名称",
          nameMax: "发布名称不能超过 255 个字符",
          visibilityScopeLabel: "可见范围",
          visibilityScopeRequired: "请选择可见范围",
          manualVisibleLabel: "手册是否对学员可见",
          targetMembersLabel: "目标成员",
          targetMembersPlaceholder: "请通过查找带回选择目标成员",
          pickTargetMembersAction: "查找带回",
          clearTargetMembersAction: "清空",
          sourceSummaryTitle: "来源摘要",
          settingsSummaryTitle: "发布设置摘要",
          targetSummaryTitle: "目标成员摘要",
          snapshotSummaryTitle: "发布快照摘要",
        },
        run: {
          afterResultLabel: "改判后的结果",
          afterResultRequired: "请选择改判结果",
          overrideReasonLabel: "改判原因",
          overrideReasonRequired: "请输入改判原因",
          operatorDisplayNameLabel: "操作人展示名",
          resetReasonLabel: "重置原因",
        },
      },
    },
  },
  en: {
    microLab: {
      forms: {
        scheme: {
          nameLabel: "Scheme Name",
          descriptionLabel: "Scheme Description",
          nameRequired: "Please enter a scheme name",
          nameMax: "Scheme name must be 255 characters or fewer",
          nameNonNumeric: "Scheme name cannot be digits only. Use a human-readable title.",
        },
        schemeShare: {
          membersLabel: "Shared Members",
          membersPlaceholder: "Select members who can view this scheme",
          pickMembersAction: "Find Share Members",
          memberSearchPlaceholder: "Search username or display name",
        },
        schemeVersion: {
          nameLabel: "Version Name",
          nameMax: "Version name must be 255 characters or fewer",
          nameNonNumeric: "Version name cannot be digits only. Use a human-readable title.",
          descriptionLabel: "Version Description",
          objectiveLabel: "Lab Objective",
          manualLabel: "Markdown Manual",
          manualRequired: "Please enter the Markdown manual",
          markdownEditor: {
            emptyPreview: "No markdown content yet",
            editMode: "Edit",
            splitMode: "Split",
            previewMode: "Preview",
            headingAction: "Heading",
            boldAction: "Bold",
            italicAction: "Italic",
            quoteAction: "Quote",
            bulletListAction: "Bullet List",
            orderedListAction: "Ordered List",
            linkAction: "Link",
            codeBlockAction: "Code Block",
            headingPlaceholder: "Section title",
            boldPlaceholder: "bold text",
            italicPlaceholder: "italic text",
            quotePlaceholder: "Quoted note",
            bulletListPlaceholder: "List item",
            orderedListPlaceholder: "Ordered item",
            linkPlaceholder: "Link text",
            codeBlockPlaceholder: "code block",
          },
          environmentKindLabel: "Environment Type",
          environmentKindRequired: "Please select an environment type",
          environmentAssetLabel: "Environment Asset",
          topologyAssetLabel: "Topology Asset",
          environmentAssetRequired: "Please select an environment asset",
          environmentImagePlaceholder: "Please select an application image asset",
          environmentTopologyPlaceholder: "Please select a topology asset",
          pickEnvironmentAssetAction: "Pick and Use",
          clearEnvironmentAssetAction: "Clear",
          ksaBindingsLabel: "Experiment-level KSA Bindings",
          ksaBindingsHelp:
            "Select KSA categories from the capability graph and save them into the formal version snapshot binding structure.",
          ksaPickerPlaceholder: "Select KSA categories",
          pickKsaAction: "Pick and Use",
          clearKsaAction: "Clear",
          ksaKnowledgeGroupTitle: "Knowledge",
          ksaSkillGroupTitle: "Skill",
          ksaAbilityGroupTitle: "Ability",
          stepsLabel: "Structured Steps",
          addStepAction: "Add Step",
          stepCardTitle: "Step {index}",
          stepTitleLabel: "Step Title",
          stepTitleRequired: "Please enter a step title",
          stepInstructionLabel: "Step Instruction",
          stepExpectedOutcomeLabel: "Expected Outcome",
          stepKsaBindingsLabel: "Step-level KSA Bindings",
          stepKsaBindingsHelp:
            "Select more specific KSA categories for this step so execution and review can locate the training objective.",
          submissionNoteLabel: "Submission Note",
        },
        library: {
          reuseModeLabel: "Reuse Mode",
          reuseModeRequired: "Please select a reuse mode",
          targetSchemeNameLabel: "Target Scheme Name",
          targetSchemeNameRequired: "Please enter a target scheme name",
          targetSchemeNameMax: "Target scheme name must be 255 characters or fewer",
          targetSchemeNamePlaceholder: "Enter the generated scheme name",
          targetVersionNameLabel: "Target Version Name",
          targetVersionNameMax: "Target version name must be 255 characters or fewer",
          targetVersionNamePlaceholder: "Optional: enter a readable first-version name",
        },
        libraryReviews: {
          actionLabel: "Action",
          actionRequired: "Please select an action",
          reviewCommentLabel: "Review Comment",
        },
        release: {
          stepSourceTitle: "Source Scheme Version",
          stepSourceDescription:
            "First confirm the scheme version to freeze into the release snapshot.",
          stepSettingsTitle: "Release Settings",
          stepSettingsDescription: "Set the visibility, manual exposure, and release name.",
          stepTargetsTitle: "Target Members",
          stepTargetsDescription: "Only targeted releases need an explicit member list.",
          stepConfirmTitle: "Snapshot Confirmation",
          stepConfirmDescription:
            "Review the source and target scope that the release will freeze.",
          sourceSchemeVersionLabel: "Source Scheme Version",
          sourceSchemeVersionRequired: "Please select a source scheme version",
          sourceSchemeVersionPlaceholder: "Please select a source scheme version",
          pickSourceSchemeVersionAction: "Pick and Use",
          clearSourceSchemeVersionAction: "Clear",
          nameLabel: "Release Name",
          nameMax: "Release name must be 255 characters or fewer",
          visibilityScopeLabel: "Visibility Scope",
          visibilityScopeRequired: "Please select a visibility scope",
          manualVisibleLabel: "Manual visible to learners",
          targetMembersLabel: "Target Members",
          targetMembersPlaceholder: "Please choose target members through the picker",
          pickTargetMembersAction: "Pick and Use",
          clearTargetMembersAction: "Clear",
          sourceSummaryTitle: "Source Summary",
          settingsSummaryTitle: "Settings Summary",
          targetSummaryTitle: "Target Members Summary",
          snapshotSummaryTitle: "Release Snapshot Summary",
        },
        run: {
          afterResultLabel: "Override Result",
          afterResultRequired: "Please select an override result",
          overrideReasonLabel: "Override Reason",
          overrideReasonRequired: "Please enter an override reason",
          operatorDisplayNameLabel: "Operator Display Name",
          resetReasonLabel: "Reset Reason",
        },
      },
    },
  },
  ja: {
    microLab: {
      forms: {
        schemeShare: {
          pickMembersAction: "共有メンバーを検索",
          memberSearchPlaceholder: "ユーザー名または表示名を検索",
        },
      },
    },
  },
};
